import { BEMBlock } from 'helpers/classnames';
import { Image } from 'palette/Image';
import { IImageObject, useProductCardContext } from 'palette/ProductCard';
import useImagesCarousel from './useImagesCarousel';
import './ImagesCarousel.scss';

type ImagesCarouselProps = {
    images?: IImageObject[];
    scrollIndicatorAnimation?: boolean;
};

function ImagesCarousel({ images, scrollIndicatorAnimation = false }: ImagesCarouselProps) {
    const [block, BEMElement] = BEMBlock('palette-image-slider');

    const {
        isAnimationActive,
        currentSlide,
        scrollContainerRef,
        imageRef,
        handleBulletClick,
        handleSliderMove,
    } = useImagesCarousel(scrollIndicatorAnimation);

    const { size: cardSize } = useProductCardContext();

    return (
        <div className={block}>
            <div
                ref={scrollContainerRef}
                className={BEMElement('slides',
                    { 'scrolling-indicator-animation': isAnimationActive })}
                onScroll={handleSliderMove}
            >
                {images?.map(({ attributes }, key) => (
                    <div
                        key={attributes.src}
                        ref={imageRef}
                        className={BEMElement('slide')}
                    >
                        <Image
                            className={BEMElement('slide-image', {
                                [`${cardSize}`]: cardSize !== undefined,
                            })}
                            loading="lazy"
                            {...attributes}
                            alt={`${attributes?.alt || ''} - ${key + 1}`}
                        />
                    </div>
                ))}
            </div>
            <div className={BEMElement('bullets')}>
                {
                    images?.map(({ attributes }, index) => (
                        <button
                            key={attributes.src}
                            className={BEMElement('bullet-button')}
                            onClick={e => handleBulletClick(e, index)}
                        >
                            <span className={BEMElement('bullet-circle', { active: index === currentSlide })} />
                        </button>
                    ))
                }
            </div>
        </div>
    );
}

export default ImagesCarousel;
